<div class="greeceText"> - GREECE -</div>
<div class="motoText">"Revive the past"</div>
<div #map id="mapRoot"></div>
